
/* injects from baggage-loader */

'use strict';

import { thumbs } from '../../../index.const';

export default class StudentAvatarController {
    constructor($log) {
        'ngInject';
        this.$log = $log;
        this.thumbs = thumbs;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/student-avatar/student-avatar.controller.js